// ** Utils
import { paginateArray } from '@utility/belt'

// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'


const appBaseURL = import.meta.env.VITE_APP_BASE_URL

// ** START:  
export const getProductServiceListF01Data = createAsyncThunk('appProduct/getProductServiceListF01Data', async (params, thunkAPI) => {
    try {

        const state = thunkAPI.getState() 

        const { sort, sortColumn, page = 1, perPage = 10, q = '', caller = '' } = params

        // if (import.meta.env.DEV) {
        //     console.log(`Called by ${caller}`)
        // }

        let data
        let tempIsDataLoaded

        /* Note state.productService is defined in 
        index.js or a js file 
        calling 
        const store = useSelector(state => state.productService.productServiceListF01) */
        if (!state.productService.productServiceListF01.isDataLoaded) {
            const response = await fetch(`${appBaseURL}/product/get-product-service-list-f01`)
            if (!response.ok) {
                throw new Error('Fetch response error at getProductServiceListF01Data', response.statusText)
            }
            // if (import.meta.env.DEV) {
            //     console.log('API call to /Product/getProductServiceListF01')
            // }

            data = await response.json()
            tempIsDataLoaded = true
        } else {

            data = state.productService.productServiceListF01.allData
            tempIsDataLoaded = state.productService.productServiceListF01.isDataLoaded
        }

        // Get from cache if isDataLoaded is false:
         
        const dataAsc = [...data].sort((a, b) => { // Pass a copy [...data] only to sort()
            let aValue, bValue
        
            // Handle cases where sortColumn might specify a nested property
            if (sortColumn.includes('.')) {
                const splitColumn = sortColumn.split('.')
                aValue = a[splitColumn[0]] ? a[splitColumn[0]][splitColumn[1]] : null
                bValue = b[splitColumn[0]] ? b[splitColumn[0]][splitColumn[1]] : null
            } else {
                aValue = a[sortColumn]
                bValue = b[sortColumn]
            }
        
            // Handling nulls - nulls will sort to the end
            if (aValue === null) return 1
            if (bValue === null) return -1
            if (aValue === null && bValue === null) return 0
        
            // General comparison
            return aValue < bValue ? -1 : aValue > bValue ? 1 : 0
        })
        
        // Determine the sorting direction
        const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

        const queryLowered = q.toLowerCase()

        const filteredData = dataToFilter.filter( 
            productService => { 
                return ((
                // productService._.toLowerCase().includes(queryLowered) ||
                // productService._.toLowerCase().includes(queryLowered) ||
                productService.name.toLowerCase().includes(queryLowered))
                )
            }
        )

        return {
            params,
            data: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page),
            allData: data,
            totalPages: filteredData.length, // TODO: Doesnt work:  Math.ceil(filteredData.length / perPage) or totalPages is a misnomer
            isDataLoaded: tempIsDataLoaded,
            caller
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)  

    }

})

export const productServiceListF01Slice = createSlice({
    name: 'productServiceListF01Slice',
    initialState: {
        params: {},
        data: [],
        allData: [],
        total: 0,
        totalPages: 0,
        loading: false, 
        isDataLoaded: false, // Controls caching mechanism to avoid unnecessary retrieval from DB 
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null 
    },

    reducers: {
        setIsDataLoaded: (state, action) => {
            state.isDataLoaded = action.payload
        }
    },

    extraReducers: builder => {
    builder.addCase(getProductServiceListF01Data.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
        state.params = action.payload.params
        state.loading = false
        // state.isDataLoaded = true is handled by async thunk's return
        state.isDataLoaded = action.payload.isDataLoaded || false // Take value from async thunk's return
        state.rejected = false
        state.error = null
    })
    builder.addCase(getProductServiceListF01Data.pending, (state) => {
        state.loading = true 
        state.rejected = false
        state.error = null
    })
    builder.addCase(getProductServiceListF01Data.rejected, (state, action) => {
        state.loading = false
        state.rejected = true
        state.error = action.error.message
        state.errActPload = action.payload
        state.errActMsg = action.error.message

        if (import.meta.env.DEV) {
            console.error(`Fetch failure at getProductServiceListF01Data as called by ${action.payload.caller}:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
    })
    }
})

// ** START:  
export const getProductServiceRowF01Data = createAsyncThunk('appProduct/getProductServiceRowF01Data', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/get-product-service-row-f01?rowId=${id}`)
        if (!response.ok) {
            throw new Error('Fetch response error at getProductServiceRowF01Data', response.statusText)
        }
        const data = await response.json()  
        return data  

    } catch (error) {
        if (import.meta.env.DEV) {
            console.error('Fetch failure at getProductServiceRowF01Data try-catch:', error)
        }
        return thunkAPI.rejectWithValue(error.message)  
    }
})

export const productServiceRowF01Slice = createSlice({
    name: 'productServiceRowF01Slice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(getProductServiceRowF01Data.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(getProductServiceRowF01Data.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(getProductServiceRowF01Data.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Fetch failure at getProductServiceRowF01Data:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Update
export const updateProductService = createAsyncThunk('appProduct/updateProductService', async ({id, formData}, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/update-product-service/${id}`, {
            method: 'PUT', 
            body: formData // Directly use FormData, without setting Content-Type header
        })

        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const productServiceUpdateSlice = createSlice({
    name: 'productServiceUpdateSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(updateProductService.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(updateProductService.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(updateProductService.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Update failure at updateProductService:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Create
export const createProductService = createAsyncThunk('appProduct/createProductService', async ({ formData }, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/create-product-service`, {
            method: 'POST', 
            body: formData // Directly use FormData, without setting Content-Type header
        })

        if (response.ok) {
            if (response.status === 204) { 
                    // Creation successful. No Content returned from endpoint
                    return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const productServiceCreateSlice = createSlice({
    name: 'productServiceCreateSlice',
    initialState: {
        data: null,
        fulfilled: false,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    reducers: {
        resetCreateState: (state) => {
            state.data = null
            state.fulfilled = false
            state.loading = false
            state.rejected = false
            state.error = null
            state.errActPload = null
            state.errActMsg = null
        }
    },
    extraReducers: (builder) => {
    builder
        .addCase(createProductService.fulfilled, (state, action) => {
            state.data = action.payload
            state.fulfilled = true
            state.loading = false
            state.rejected = false
            state.error = null
            if (import.meta.env.DEV) {
                console.log(`Success at createProductService:\n Data: ${JSON.stringify(state.data, null, 2)}`)
            }
        })
        .addCase(createProductService.pending, (state) => {
            state.fulfilled = false
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(createProductService.rejected, (state, action) => {
            state.fulfilled = false
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
            if (import.meta.env.DEV) {
                console.error(`Create failure at createProductService\:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
            }
        })
    }
})


// ** START Delete
export const deleteProductService = createAsyncThunk('appProduct/deleteProductService', async (id, thunkAPI) => {
    try {
        const response = await fetch(`${appBaseURL}/product/delete-product-service/${id}`, {
            method: 'DELETE', 
            headers: { 
                'Content-Type': 'application/json'
                // TBI: 'Authorization': 'Bearer ' + AccessToken 
            }
        })

        if (response.ok) {
            if (response.status === 204) { 
                // Update successful. No Content returned from endpoint
                return null
            } else {
                const data = await response.json()
                return data
            }
        } else {
            return thunkAPI.rejectWithValue(await response.json())
        }

    } catch (error) {
        return thunkAPI.rejectWithValue(error.message)
    }
})

export const productServiceDeleteSlice = createSlice({
    name: 'productServiceDeleteSlice',
    initialState: {
        data: null,
        loading: false,
        rejected: false,
        error: null,
        errActPload: null,
        errActMsg: null
    },
    // reducers: {},
    extraReducers: (builder) => {
    builder
        .addCase(deleteProductService.fulfilled, (state, action) => {
            state.data = action.payload
            state.loading = false
            state.rejected = false
            state.error = null
        })
        .addCase(deleteProductService.pending, (state) => {
            state.loading = true
            state.rejected = false
            state.error = null
        })
        .addCase(deleteProductService.rejected, (state, action) => {
            state.loading = false
            state.rejected = true
            state.error = action.error.message
            state.errActPload = action.payload
            state.errActMsg = action.error.message
        if (import.meta.env.DEV) {
            console.error(`Delete failure at deleteProductService:\n Payload: ${state.errActPload} \nError Msg: ${state.errActMsg}`)
        }
        })
    }
})

// Export actions
export const { setIsDataLoaded } = productServiceListF01Slice.actions
export const { resetCreateState } = productServiceCreateSlice.actions

// Combine reducers
const productServiceReducer = combineReducers({
    productServiceListF01: productServiceListF01Slice.reducer,
    productServiceRowF01: productServiceRowF01Slice.reducer,
    productServiceCreate: productServiceCreateSlice.reducer,
    productServiceUpdate: productServiceUpdateSlice.reducer,
    productServiceDelete: productServiceDeleteSlice.reducer
})


export default productServiceReducer